// AI Generated Component
import { Component, OnInit } from '@angular/core';
import { StateService } from '@uirouter/core';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { SessionService } from '@monsido/core/session/session.service';
import { DateRangeService } from '@client/app/services/date-range/date-range.service';
import { ParamService } from '@monsido/ng2/core/param/param.service';
import { StatsRepoService } from '@client/app/services/api/stats-repo/stats-repo.service';
import { PipeService } from '@client/app/filters/pipe-transformation.service';
import moment from 'moment';

@Component({
    selector: 'statistics-visitors-devices',
    standalone: false,
    templateUrl: './devices.component.html',
})
export class StatisticsVisitorsDevicesComponent implements OnInit {
    pageChange = this.onPageChange.bind(this);
    perPageChange = this.onPerPageChange.bind(this);
    updateDateRange = this.onUpdateDateRange.bind(this);
    average = this.calculateAverage.bind(this);
    itemClass = this.getItemClass.bind(this);

    domain: any;
    totalVisits: number = 0;
    pageSize: number = 100;
    summary: any = {};
    date: any;
    dateFormat = 'ddd, D. MMM YYYY';
    pages: any[] = [];
    doughnutLabels: any[] = [];
    doughnutData: any[] = [];
    barData: any[] = [];
    chartColors: string[] = ['#3669d3', '#89cdfd', '#3da3e9'];
    doughnutOptions: any = {};
    barOptions: any = {};
    barOverride: any[] = [];
    exports: any[] = [];
    promise: any;
    page: any;
    loading: boolean = false;

    constructor (
        private statsRepoService: StatsRepoService,
        private stateService: StateService,
        private paramService: ParamService,
        private translateService: TranslateService,
        private sessionService: SessionService,
        private dateRangeService: DateRangeService,
        private pipeService: PipeService,
    ) {}

    ngOnInit () {
        this.activate();
    }

    activate () {
        this.domain = this.sessionService.domain;
        this.totalVisits = 0;
        this.pageSize = 100;
        this.summary = {};
        this.date = this.dateRangeService.setRangeDates();

        this.pages = [];
        this.doughnutLabels = [];
        this.doughnutData = [];
        this.barData = [];
        this.chartColors = ['#3669d3', '#89cdfd', '#3da3e9'];
        this.doughnutOptions = {
            legend: {
                display: true,
                position: 'bottom',
                onHover: function (element: any) {
                    element.target.style.cursor = 'pointer';
                },
                onLeave: function (element: any) {
                    element.target.style.cursor = 'default';
                },
            },
            tooltips: {
                callbacks: {
                    title: () => {
                        return this.translateService.getString('Visits');
                    },
                    label: (tooltipItem: any, data: any) => {
                        return this.pipeService.get('monNumber')(data.datasets[0].data[tooltipItem.index]);
                    },
                },
            },
        };
        this.barOptions = {
            legend: {
                display: false,
            },
            scales: {
                xAxes: [
                    {
                        ticks: {
                            beginAtZero: true,
                            callback: (value: any) => {
                                return this.pipeService.get('monNumber')(value, '0,0');
                            },
                            min: 0,
                        },
                    },
                ],
                yAxes: [
                    {
                        gridLines: {
                            display: false,
                        },
                    },
                ],
            },
            tooltips: {
                intersect: false,
                callbacks: {
                    label: (tooltipItem: any, data: any) => {
                        return (
                            this.pipeService.get('monNumber')(data.datasets[0].data[tooltipItem.index]) +
                            ' ' +
                            this.translateService.getString('Visits')
                        );
                    },
                },
            },
        };

        this.barOverride = [
            {
                borderWidth: 0,
                borderColor: ['#3669d3', '#89cdfd', '#3da3e9'],
                backgroundColor: ['#3669d3', '#89cdfd', '#3da3e9'],
            },
        ];

        this.onUpdateDateRange();
    }

    getPage () {
        this.loading = true;
        this.promise = Promise.all([this.getPages(), this.getSummary()]).finally(() => {
            this.loading = false;
        });
    }

    getPages () {
        const params = {
            limit: this.pageSize || 100,
            page: this.page || 1,
            domainId: this.stateService.params.domainId,
            from: this.date.startDate.format('YYYY-MM-DD'),
            to: this.date.endDate.format('YYYY-MM-DD'),
        };
        this.exports = [
            {
                tooltip: this.translateService.getString('Export visitors devices'),
                name: this.translateService.getString('Visitors devices export'),
                data: {
                    category: 'visitors_devices',
                    category_ref: this.date.startDate?.format('YYYY-MM-DD') + ',' + this.date.endDate?.format('YYYY-MM-DD'),
                },
            },
        ];
        let others = 0;
        return this.statsRepoService.getDevices(params).then((data: any) => {
            this.pages = data.filter((device: any) => {
                return device.visits > 0;
            });
            this.totalVisits = data.reduce((total: number, page: any) => {
                return total + parseInt(page.visits);
            }, 0);
            this.doughnutLabels = [];
            this.doughnutData = [];
            for (let i = 0; i < this.pages.length; i++) {
                if (i < 5) {
                    this.doughnutLabels.push(this.pages[i].label);
                    this.doughnutData.push(this.pages[i].visits);
                } else {
                    others += parseInt(this.pages[i].visits);
                }
            }
            if (this.pages.length > 5) {
                this.doughnutLabels.push(this.translateService.getString('Others'));
                this.doughnutData.push(others);
            }

            this.barData = [this.doughnutData];
        });
    }

    getSummary () {
        const params = {
            domainId: this.stateService.params.domainId,
            from: this.date.startDate.format('YYYY-MM-DD'),
            to: this.date.endDate.format('YYYY-MM-DD'),
            type: 'total',
        };
        return this.statsRepoService.getSummary(params).then((data: any) => {
            this.summary = data;
        });
    }

    onPageChange (page: any) {
        this.page = page;
        this.getPage();
    }

    onPerPageChange (pageSize: any) {
        this.pageSize = pageSize;
        this.getPage();
    }

    onUpdateDateRange () {
        if (this.date.startDate || this.date.endDate) {
            this.paramService.setParams({
                from: moment(this.date.startDate),
                to: moment(this.date.endDate),
            });
            this.getPage();
        }
    }

    calculateAverage (array: any, prop: string) {
        let sum = 0;
        if (!Array.isArray(array) || array.length === 0) {
            return 0;
        }
        array.forEach((item: any) => {
            sum += parseInt(item[prop]);
        });
        return sum / array.length;
    }

    getItemClass (index: number) {
        switch (index) {
            case 0:
                return 'visitor-summary-devices__first';
            case 1:
                return 'visitor-summary-devices__second';
            case 2:
                return 'visitor-summary-devices__third';
            default:
                return '';
        }
    }

    trackByIndex (index: number, item: any): number {
        return index;
    }
}
